<h3 style="margin-top: 0; margin-bottom: 0; color: #028da8;"><i class="fa-solid fa-house-laptop"></i> {{ stats?.total }} Properties</h3>
<p class="hide">{{ stats?.published }} Published</p>